
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner/[url_path]",
      function () {
        return require("private-next-pages/partner/[url_path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner/[url_path]"])
      });
    }
  